import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../Components/Navbar/navbar.css';
import { AuthContext } from '../../Context/auth';
import Conexao from '../../Config/conexao';
import axios from 'axios';

function NavbarSSMT() {

  /*   const { setLogado } = useContext(AuthContext);
  
    function Logout() {
      setLogado(false);
      localStorage.removeItem("logado");
    } */


    const [setorLogado, setSetorLogado]=useState();
    const [setorDoCargo, setSetorDoCargo]=useState();
  
  
    function carregaUser(){setSetorLogado (localStorage.usuario) }; 
    useEffect(() => { carregaUser() });  
  
   async function getSetor() {  
     const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado );        
     if (res.data.success === false) {
     //  setLoading(false)
     //  falha();  
     } else {  
     setSetorDoCargo(res.data.setor);
    // console.log( "SEETOOOOOR  " + setorDoCargo);
     console.log(  res.data.setor);
     console.log( "QUEEEEM  " + setorLogado);
     }   
       };
  
  
       useEffect(() => { getSetor() },[]);   




  return <nav className="navbar fixed-top navbar-expand-md navbar-dark">

    <div className="container-fluid">

      <a className="navbar-brand" href="/app/home">
        <img src="/Images/logoGeocontrole.png" alt="" height='50px' />
      </a>

      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link to="/app/home" className="nav-link logout" aria-current="page" >Menu Principal</Link>
          </li>
          <li className="nav-item">
            <Link to="/app/DashBoardSSMT" className="nav-link logout" aria-current="page" >DashBoard EPIs</Link>
          </li>

          <li className="nav-item">
            <Link to="/app/DashboardPlanoDeAcoesSSMT" className="nav-link logout" aria-current="page" >DashBoard plano de ação</Link>
          </li>

          

        

          <li   className="nav-item">
            <Link to="/app/Epis"className="nav-link logout" aria-current="page" >EPI </Link>
          </li>
         




          <li  className="nav-item">
            <Link to="/app/PlanoDeAcoesSSMT"  className="nav-link logout" aria-current="page" >Plano de ações </Link>
          </li>      




          <li className="nav-item dropdown">
            <div className="dropdown" >
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle"  href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">  Check-Lists</a>

                <ul class="dropdown-menu">

                  <li><Link to="/app/ChecklistPipa" className="dropdown-item" aria-current="page" >Check-list Caminhão Pipa </Link></li>

                  <li><Link to="/app/CheckListCaminhaoPrancha" className="dropdown-item" aria-current="page" >Check-list Caminhão Prancha</Link></li>

                  <li><Link to="/app/ChecklistDiariaSonda" className="dropdown-item" aria-current="page" >Check-list Díario de Sonda </Link></li>

                  <li><Link to="/app/ChecklistDiariaVeiculos" className="dropdown-item" aria-current="page" >Check-list Inspeção diaria de Veículos</Link></li>

                  <li><Link to="/app/ChecklistFadiga" className="dropdown-item" aria-current="page" >Check-list Diário Sobre Fadiga</Link></li>

                  <li><Link to="/app/ChecklistAlojamento" className="dropdown-item" aria-current="page" >Check-list Alojamento</Link></li>

                  <li><Link to="/app/ChecklistPreCampo" className="dropdown-item" aria-current="page" >Check-list Pré Campo</Link></li>

                  <li><Link to="/app/ChecklistMeioAmbiente" className="dropdown-item" aria-current="page" >Check-list inspeção de Meio Ambiente</Link></li>

                  <li><Link to="/app/ChecklistComponentes" className="dropdown-item" aria-current="page" >Check-list  Componentes e Acessórios </Link></li>

                  <li><Link to="/app/ChecklistFerramentas" className="dropdown-item" aria-current="page" >Check-list Ferramentas Manuais </Link></li>

                  <li><Link to="/app/ChecklistExtintores" className="dropdown-item" aria-current="page" >Check-list Extintores </Link></li>

                  <li><Link to="/app/ChecklistFogareiro" className="dropdown-item" aria-current="page" >Check-list Fogareiro </Link></li>

                  <li><Link to="/app/ChecklistKitAmbiental" className="dropdown-item" aria-current="page" >Check-list Kit-Ambiental </Link></li>

                  <li><Link to="/app/ChecklistPracaSondagem" className="dropdown-item" aria-current="page" >Check-list Praça de Sondagem </Link></li>

                  <li><Link to="/app/ChecklistInspecaoCampo" className="dropdown-item" aria-current="page" >Check-list Inspeção de Campo </Link></li>

                  <li><Link to="/app/OcorrenciasCampo" className="dropdown-item" aria-current="page" >Check-list Ocorrencias Campo </Link></li>
                  <li><Link to="/app/RelatoDeIncidente" className="dropdown-item" aria-current="page" >Check-list Relato De Incidente </Link></li>



                </ul>
              </li>
            </div>
          </li>



          <li className="nav-item">
            <a href="/#" className="nav-link logout" aria-current="page" >Sair</a>
          </li>
        </ul>
      </div>

    </div>
  </nav>;
}

export default NavbarSSMT;